import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavigationProps } from '../../types';
import './Navigation.css';

const Navigation: React.FC<NavigationProps> = ({ links = [], onLinkClick, isMobile = false }) => {
  const location = useLocation();

  const handleLinkClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <nav className={`navigation ${isMobile ? 'mobile' : ''}`}>
      <ul className={`nav-list ${isMobile ? 'mobile' : ''}`}>
        {links.map((link, index) => (
          <li key={index} className="nav-item">
            {link.href.startsWith('/') ? (
              <Link 
                to={link.href} 
                className={`nav-link ${location.pathname === link.href ? 'active' : ''}`}
                onClick={handleLinkClick}
              >
                {link.text}
              </Link>
            ) : (
              <a href={link.href} className="nav-link" onClick={handleLinkClick}>
                {link.text}
              </a>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
